<template>
  <div class="oee-chart">
    <div class="oee-chart-title">
      FTT<dv-decoration-3 style="width: 70%; height: 30px; float: right" />
    </div>
    <dv-decoration-10 style="width: 98%; height: 5px" />
    <!-- <dv-charts :option="option" /> -->
    <div style="width: 100%; height: 100%" id="ftqCharts"></div>
  </div>
</template>

<script>
export default {
  name: "ftqChart",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      datas: this.beans,
      option: {},
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.datas = val;
        this.createData();
      },
      deep: true,
    },
  },
  methods: {
    decimal2(num) {
      // 先将数字乘以 10，使用 toFixed 方法将结果保留 0 位小数，再除以 10
      if (num == 0 || num == 100) {
        return num;
      }
      let result = parseFloat((num * 10).toFixed(0)) / 10;
      return result;
    },
    createData() {
      var data = this.datas;
      var pipeo = this.$echarts.init(document.getElementById("ftqCharts"));

      const xAxis = [];
      const lineData = [];
      const lineKpi = [];
      data.forEach((item) => {
        xAxis.push(item.week);
        lineData.push(this.decimal2(item.ftq));
        lineKpi.push(item.ftqKpi);
      });

      var option = {
        grid: {
          bottom: 55,
          top: 25,
          x: 40,
          y2: 0,
        },
        xAxis: [
          {
            name: "WK", // 给X轴加单位
            nameLocation: "end",
            nameGap: 5,
            type: "category",
            nameTextStyle: {
              color: "#ffffff",
            },
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: 11,
              },
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "%",
            nameGap: 5,
            min: 60,
            axisLabel: {
              formatter: "{value}",
            },
            splitLine: {
              lineStyle: {
                type: "dashed", //虚线
              },
              show: true, //隐藏
            },
            axisLine: {
              show: true,
              symbolOffset: 10,
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        label: {
          show: true,
          position: "inside",
          style: {
            fontSize: 10,
          },
          formatter: (params) => {
         //   return params.value + "%";
		 return params.value
          },
        },
        series: [
          {
            name: "实际",
            type: "bar",
            data: lineData,
            barGap: "-100%",
            barWidth: 22,
            itemStyle: {
              normal: {
                color: function (params) {
                  return params["value"] >= lineKpi[0] ? "#00E690" : "red";
                },
              },
            },
            markLine: {
              symbol: ["none", "none"], //去掉箭头
              lineStyle: {
                type: "dashed",
                normal: {
                  type: "solid",
                  color: "#00E690 ", // 这儿设置安全基线颜色
                },
              },
              data: [
                {
                  yAxis: lineKpi[0],
                },
              ],
              label: {
                show: true,
				distance: [-20, 0],
                position: "insideStartBottom",
                color: "#00E690",
              },
            }
          },
        ],
      };

      pipeo.setOption(option);
    },
  },
  mounted() {
    //const { createData } = this
    //this.createData()
    // setInterval(createData, 30000)
  },
};
</script>

<style lang="less">
.oee-chart {
  width: 100%;
  height: 100%;
  //  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;

  .oee-chart-title {
    height: 30px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/oee/component/ftqChart.vue